//
//
//
//
//
//
//
//
//
//
//
//
//

import { Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../Landing.constants'

export default {
  components: {
    Typography,
  },
  computed: {
    ...mapGetters({
      seoText: 'landing/seoText',
    }),
    dataSelectorAttribute: () => SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  },
}
